import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
export function NotFoundPage() {
  return <div className="min-h-screen w-full bg-[#0a0e1a] flex flex-col" data-id="element-320" data-mp="2t20jhqdrnnj2">
      <SEO title="Seite nicht gefunden | CRM Kraft" description="Diese Seite existiert nicht. Zur Close CRM Agentur Checkliste auf der Startseite." noindex data-id="element-321" data-mp="2t0pfpqkbmfry" />
      <Navigation data-id="element-322" data-mp="31tspnovrcahu" />
      <main className="flex-1 flex items-center justify-center px-4 pt-24 pb-16" data-id="element-323" data-mp="31wewtneqknzj">
        <div className="text-center max-w-md" data-id="element-324" data-mp="3gr2zktsr58bg">
          <p className="text-[#ff6b35] font-semibold mb-3" data-id="element-325" data-mp="3bsrq4k6dcztr">404</p>
          <h1 className="text-3xl font-bold text-white mb-4" data-id="element-326" data-mp="3bqf9qbg9exit">
            Diese Seite gibt es nicht
          </h1>
          <p className="text-gray-400 mb-8" data-id="element-327" data-mp="1mfeqh897bzyz">
            Alle Inhalte findest du auf unserer Startseite.
          </p>
          <Link to="/" className="inline-flex items-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-328" data-mp="wc8wt7z6iqo4">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-329" data-mp="15cxa20gr0mzy" />
            Zur Startseite
          </Link>
        </div>
      </main>
      <Footer data-id="element-330" data-mp="1a3nenbhcoltl" />
    </div>;
}